import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  fullscreen: true,
  class: "ion-padding",
  style: {"overflow":"auto","height":"100%"},
  id: "bg-image"
}

import { IonApp, loadingController, toastController, useIonRouter } from '@ionic/vue';
import { App } from '@capacitor/app';
import { Configuration, MobileApiFactory } from 'plate-vision-demo-openapi-client';
import { AxiosError } from 'axios';
import { Device, DevicePlugin, GetLanguageCodeResult } from '@capacitor/device';
import { useI18n } from 'vue-i18n';
import { RouterView } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const mobileApi = MobileApiFactory(new Configuration({ basePath: process.env.VUE_APP_PATH }));
const regex = /^.*\/api\/mobile\/tokens\/verification\//;
const router = useIonRouter();

App.addListener('appUrlOpen', async ({ url }) => {
    console.log('App opened with URL:', url);

    if (url.match(regex)) {
        const loading = await loadingController.create({
            message: 'Verifying email...',
        });
        await loading.present();
        const verificationToken = url.replace(regex, '');
        mobileApi
            .verifyToken(verificationToken, false)
            .then(async () => {
                const toast = await toastController.create({
                    message: 'Email verified successfully!',
                    duration: 2000,
                    position: 'middle',
                    color: 'success',
                });
                await toast.present();
                router.push({ name: 'emailConfirm' });
            })
            .catch(async (error: Error | AxiosError) => {
                if ('isAxiosError' in error && error.isAxiosError && error.response?.status == 404) {
                    const toast = await toastController.create({
                        message: 'Email has already been verified.',
                        duration: 3000,
                        position: 'middle',
                        color: 'primary',
                    });
                    await toast.present();
                    router.push({ name: 'homepage' });
                    return;
                }
                const toast = await toastController.create({
                    message: 'An unexpected error occurred, link might be invalid.',
                    duration: 4000,
                    position: 'middle',
                    color: 'danger',
                });
                await toast.present();
                router.push({ name: 'terms' });
            })
            .finally(() => {
                loading.dismiss();
            });
    }
});

const device: DevicePlugin = Device;
const i18n = useI18n();

device.getLanguageCode().then((res: GetLanguageCodeResult) => {
    console.log('Default lang', res.value);
    if (res.value.includes('-')) {
        const language = res.value.split('-')[0];
        i18n.locale.value = language;
    } else {
        i18n.locale.value = res.value;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(RouterView))
      ])
    ]),
    _: 1
  }))
}
}

})